document.addEventListener('livewire:navigated', () => {
    attachObserver(document.querySelectorAll('img[srcset]'))
});

Livewire.hook('morph.updated', ({ el }) => {
    if (el.tagName.toLowerCase() === 'img' && el.hasAttribute('srcset')) {
        attachObserver(el)
    }
});

function attachObserver(elements) {
    elements = elements instanceof NodeList ? [...elements] : [elements];

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                const size = img.getBoundingClientRect().width;

                if (!size) return;

                img.sizes = Math.ceil(size / window.innerWidth * 100) + 'vw';
                observer.unobserve(img);
            }
        });
    });

    elements.forEach((element) => observer.observe(element));
}

window.ondragstart = function () {
    return false;
};
